import { Action } from 'redux-actions';
import { createReducer } from 'redux-create-reducer';
import actions from './actions';

export interface IState {
    config?: any;
    status: {
        config?: string
    };
    youtubeHeight: number;
    navbarShadow: boolean;
};

const initialState: IState = {
    config: null,
    navbarShadow: false,
    status: {
    },
    youtubeHeight: 360,
};

export default createReducer(initialState, {
    [actions.types.FETCH_CONFIG.REQUEST]: (state: IState, action: Action<{}>) => ({
        ...state,
        status: {
            ...state.status,
            config: 'request'
        }
    }),
    [actions.types.FETCH_CONFIG.SUCCESS]: (state: IState, action: Action<any>) => ({
        ...state,
        config: action.payload,
        status: {
            ...state.status,
            config: 'success',
        },
    }),
    [actions.types.FETCH_CONFIG.FAILURE]: (state: IState, action: Action<any>) => ({
        ...state,
        status: {
            ...state.status,
            config: 'failure',
        },
    }),
});


// WEBPACK FOOTER //
// ./src/redux/modules/hft/reducer.tsx